import { jQuery } from './utils/jquery';
import { Swiper, Navigation } from 'swiper';

jQuery(function () {
    setTimeout(function () {
        if (jQuery('.js-products-slider-3').length) {
            var productSlider3 = new Swiper(".js-products-slider-3", {
                modules: [Navigation],
                speed: 500,
                simulateTouch: true,
                spaceBetween: -1,
                loop: true,
                slidesPerView: "auto",
                centeredSlides: true,
                navigation: {
                    nextEl: ".js-products-slider-next",
                    prevEl: ".js-products-slider-prev",
                },
            });
        }
    }, 2000);
});